import { FooterContainer, PageContainer, Container } from './Footer.styles'

export const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <PageContainer>
        <Container>Footer</Container>
      </PageContainer>
    </FooterContainer>
  )
}
